import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download } from 'lucide-react';

const StickyDownload = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsVisible(window.scrollY > 500);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    className="fixed bottom-6 right-6 z-50"
                    initial={{ opacity: 0, scale: 0.5, y: 50 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.5, y: 50 }}
                    transition={{ duration: 0.4, type: "spring", stiffness: 200 }}
                >
                    <motion.a
                        href="https://www.smronline.org/smronline.apk"
                        download
                        className="flex items-center gap-3 bg-gradient-primary text-white px-8 py-5 rounded-2xl font-bold text-lg shadow-2xl hover:shadow-xl transition-shadow duration-300"
                        style={{
                            boxShadow: '0 10px 40px rgba(76, 175, 80, 0.4), 0 0 20px rgba(76, 175, 80, 0.2)'
                        }}
                        animate={{
                            scale: [1, 1.05, 1],
                            boxShadow: [
                                '0 10px 40px rgba(76, 175, 80, 0.4), 0 0 20px rgba(76, 175, 80, 0.2)',
                                '0 15px 50px rgba(76, 175, 80, 0.5), 0 0 30px rgba(76, 175, 80, 0.3)',
                                '0 10px 40px rgba(76, 175, 80, 0.4), 0 0 20px rgba(76, 175, 80, 0.2)'
                            ]
                        }}
                        transition={{
                            duration: 2,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <motion.div
                            animate={{ rotate: [0, -10, 10, -10, 0] }}
                            transition={{ duration: 1.5, repeat: Infinity, repeatDelay: 2 }}
                        >
                            <Download className="w-6 h-6" />
                        </motion.div>
                        <span>Download Now</span>
                    </motion.a>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default StickyDownload;
